import RegistrationInfoDto from './RegistrationInfoDto';
import ParticipantExtraInformation from './ParticipantExtraInformation';
import ParticipantTicketDetailsDto from './ParticipantTicketDetailsDto';
import ParticipantSessionCheckInDetailsDto from './ParticipantSessionCheckInDetailsDto';
import ParticipantNotesDto from './ParticipantNotesDto';

/** Maps InviteEmailStatus string → numeric code used for email badge colour in the grid. */
// const INVITE_STATUS_TO_NUMERIC: Readonly<Record<string, number>> = {
//   Unsent:  0,
//   Sending: 1,
//   Bounced: 9,
// };

/** Backend DTO for a single event attendee — mirrors the server's EventAttendeeDto exactly. */
export class EventAttendeeDto {
  public static createEmpty(): EventAttendeeDto {
    return new EventAttendeeDto();
  }

  constructor(
    // ── Identity ──────────────────────────────────────────────────────────
    public ParticipantId: number | null = null,
    public Id: number = 0,
    public InviteeId: number | null = null,
    public ParticipantApplicationInstanceId: number | null = null,

    // ── Profile ───────────────────────────────────────────────────────────
    public FirstName: string = '',
    public LastName: string = '',
    public Email: string = '',
    public Phone: string = '',
    public Company: string = '',
    public Title: string = '',
    public PhotoUrl: string = '',
    public IconUrl: string = '',
    public About: string = '',

    // ── Social ────────────────────────────────────────────────────────────
    public TwitterHandle: string = '',
    public FacebookProfileId: string = '',
    public LinkedInPublicProfileUrl: string = '',
    public Instagram: string = '',
    public Website: string = '',

    // ── List-view registration columns ────────────────────────────────────
    public OverallStatus: number = 0, // numeric code derived from InviteEmailStatus (used for badge colour in grid)
    public InviteEmailStatus: string | null = null,
    public RegistrationStatus: string | null = null,
    public RegisteredOn: string | null = null,

    // ── Registration tab ──────────────────────────────────────────────────
    public Registration: RegistrationInfoDto | null = null,

    // ── Groups ────────────────────────────────────────────────────────────
    public GroupIds: number[] = [],
    public GroupsList: string = '',
    public ParticipantGroupsList: string[] = [],

    // ── My Information ────────────────────────────────────────────────────
    public ExtraInformations: ParticipantExtraInformation[] = [],

    // ── Tickets & Check-ins ───────────────────────────────────────────────
    public CheckInStatus: boolean = false,
    public CheckInDateTime: string | null = null,
    public IsLoggedInApp: boolean = false,
    public JoinedByAndroid: boolean = false,
    public JoinedByIOS: boolean = false,
    public JoinedByPWA: boolean = false,
    public ParticipantTicketCheckInStatus: number = 0,
    public DoesParticipantHaveNonCheckedInAdminAssignedTicket: boolean = false,
    public TicketIssuedBy: string = '',
    public BarCode: string = '',
    public ParticipantTicketDetails: ParticipantTicketDetailsDto[] = [],
    public ParticipantSessionCheckInDetails: ParticipantSessionCheckInDetailsDto[] = [],

    // ── Notes ─────────────────────────────────────────────────────────────
    public ParticipantNotes: ParticipantNotesDto[] = [],
  ) {}

  get Name(): string {
    return `${this.FirstName} ${this.LastName}`.trim();
  }

  /** Numeric code derived from InviteEmailStatus — used by the grid's badge colour helper. */
  // get OverallStatus(): number {
  //   return INVITE_STATUS_TO_NUMERIC[this.InviteEmailStatus ?? ''] ?? 2;
  // }
}
